import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Button,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "../../../components/ui";
import { toast } from "react-toastify";
import axiosInstance from "../../../axios/axiosInstance";
import { handeleUpdateStatus } from "../../../utils/update-request-status";

interface Prop {
  onClose: () => void;
  id?: any;
  requestData?: any;
  requestId?: any;
}

const ApartmentType = [
  { label: "Residence", value: "residence" },
  { label: "Company", value: "company" },
  { label: "Club", value: "club" },
];
const AppartmentForm: React.FC<Prop> = ({
  onClose,
  id,
  requestData,
  requestId,
}) => {
  const role = localStorage.getItem("role");
  const [block, setBlock] = useState<any>([]);
  const [formData, setFormData] = useState<any>({ apartment_type: "company" });
  const [initialFormData, setInitialFromData] = useState<any>();

  const handleChage = (field: string, value: string) => {
    setFormData((prev: any) => ({ ...prev, [field]: value }));
  };
  const handleGetBlocks = async () => {
    try {
      const resp: any = await axiosInstance.get("/api/block");
      if (resp?.status === 200) {
        setBlock(resp?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  const handleCreate = async () => {
    try {
      // When approving a request, execute directly without invocation
      const url = requestId 
        ? `/api/appartment` 
        : `/api/appartment?invocation=${role}`;
      
      const resp: any = await axiosInstance.post(url, formData);
      if (resp?.status === 200) {
        if (requestId) {
          handeleUpdateStatus(requestId, "1");
        }

        if (requestId) {
          toast.success(`Request approved and ${formData?.apartment_type} created successfully`);
        } else if (Number(role)) {
          toast.success(
            `Add ${formData?.apartment_type} request sent to Super Admin`
          );
        } else {
          toast.success(`${formData?.apartment_type} created successfully`);
        }
        onClose();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body || error?.message);
    }
  };

  const handleUpdate = async (id: any) => {
    try {
      // When approving a request, execute directly without invocation
      const url = requestId 
        ? `/api/appartment/${id}` 
        : `/api/appartment/${id}?invocation=${role}`;
      
      const resp: any = await axiosInstance.put(url, formData);
      if (resp?.status === 200) {
        if (requestId) {
          handeleUpdateStatus(requestId, "1");
        }

        if (requestId) {
          toast.success(`Request approved and ${formData?.apartment_type} updated successfully`);
        } else if (Number(role)) {
          toast.success(
            ` Edit ${formData?.apartment_type} request sent to Super Admin`
          );
        } else {
          toast.success(
            `${formData?.apartment_type}  details updated successfully`
          );
        }
        onClose();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body || error?.message);
    }
  };

  const handleGet = async (id: any) => {
    try {
      const resp: any = await axiosInstance.get(`/api/appartment/${id}`);

      if (resp?.status === 200) {
        resp.data.data.block_id = resp?.data?.data?.block?.id;
        console.log("iddd", resp?.data?.data);

        setFormData(resp?.data?.data);
        setInitialFromData(resp?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  const handleSave = async () => {
    if (id) {
      const noFieldChange =
        JSON.stringify(formData) === JSON.stringify(initialFormData);
      if (noFieldChange) {
        toast.info("No changes were made");
        return;
      }
    }

    if (requestData) {
      if (!(JSON.stringify(formData) === JSON.stringify(initialFormData))) {
        formData.is_admin_made_change = true;
      }
    }

    if (!formData?.appartment_name) {
      toast.error(`${formData?.apartment_type} name is required`);
      return;
    } else if (!formData?.appartment_no) {
      toast.error(`${formData?.apartment_type} no is required`);
      return;
    } else if (!formData?.floor) {
      toast.error("floor is required");
      return;
    } else if (!formData?.block_id) {
      toast.error("block is required");
      return;
    }
    formData.role = role;

    if (id) {
      await handleUpdate(id);
    } else {
      await handleCreate();
    }
  };
  useEffect(() => {
    id && handleGet(id);
    console.log(id);
  }, [id]);
  useEffect(() => {
    handleGetBlocks();
  }, []);

  useEffect(() => {
    requestData && setFormData(requestData);
    requestData && setInitialFromData(requestData);
  }, [requestData]);
  console.log(formData);

  return (
    <div>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Typography fontSize={18} fontWeight={500} color="#1F2937">
            {id ? "Edit Apartment" : "Add Apartment"}
          </Typography>
        </Grid>
        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>
              Type <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>
            <Select
              size="small"
              value={formData?.apartment_type ? formData?.apartment_type : 0}
              onChange={(e) => handleChage("apartment_type", e?.target?.value)}
            >
              {ApartmentType.map((item: any) => (
                <MenuItem key={item?.value} value={item?.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>
        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>
              {formData?.apartment_type == "company" && "Company Name"}
              {formData?.apartment_type == "residence" && "Residence Name"}
              {formData?.apartment_type == "club" && "Club Name"}
              <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>
            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              value={formData?.appartment_name}
              onChange={(e: any) =>
                handleChage("appartment_name", e?.target.value)
              }
            />
          </Box>
        </Grid>
        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>
              {formData?.apartment_type == "company" && "Company No"}
              {formData?.apartment_type == "residence" && "Residence No"}
              {formData?.apartment_type == "club" && "Club No"}
              <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>
            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              value={formData?.appartment_no}
              onChange={(e: any) =>
                handleChage("appartment_no", e?.target.value)
              }
            />
          </Box>
        </Grid>
        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>
              Floor <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>
            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              value={formData?.floor}
              onChange={(e: any) => handleChage("floor", e?.target.value)}
            />
          </Box>
        </Grid>
        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>
              Block <span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>

            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              size={"small"}
              value={formData?.block_id ? formData?.block_id : 0}
              onChange={(e: any) => handleChage("block_id", e?.target?.value)}
            >
              {block?.map((item: any, index: any) => (
                <MenuItem value={item?.id} key={index}>
                  {item?.block_name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>

        <Grid size={12} display={"flex"} justifyContent={"end"}>
          {" "}
          <Box display={"display"}>
            <Button
              size="small"
              variant="contained"
              sx={{ mx: 1, bgcolor: "#1F2937" }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              size="small"
              variant="outlined"
              sx={{ color: "#1F2937", borderColor: "#1F2937" }}
              onClick={onClose}
            >
              Close
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default AppartmentForm;
